/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Matthew Quinn, GRAND Creative Inc.
 * Copyright 2012
 *
 * Dependancies: JQuery 1.8, easing.js
 *
*/

//create a custom namespace for our Utilities
function Utils() {}

/* Utility Funcitons,  Matthew Quinn, GRAND Creative Inc.  Copyright 2012
 *
 *  Description:
 *    Detects various platforms environments. Mostly used for platform hacks/polyfills.
 *
 *
*/

/* Detect Android 2 */

Utils.prototype = {

  isAndroid2: function isAndroid2() {
    var ua = navigator.userAgent.toLowerCase();

    if (ua.indexOf("android 2") > -1) {
      return true;
    }

    return false;
  },

  /* Detect BlackBerry7 and under */

  isBlackBerry: function isBlackBerry() {
    var ua = navigator.userAgent.toLowerCase();

    if (ua.indexOf("blackberry") > -1) {
      return true;
    }

    return false;
  },

  /* Detect Windows Phone and under */

  isWindowsPhone: function isWindowsPhone() {
    return navigator.userAgent.match(/(windows phone)/i) ? true : false;
  },

  /* Detect BlackBerry7 and under */

  isiOS: function isiOS() {
    return navigator.userAgent.match(/(iPad|iPhone|iPod)/i) ? true : false;
  },

  /* Detect if the browser can play H264 mp4s */

  canPlayh264: function canPlayh264() {
    var v = document.createElement('video'),
        canPlayVideo = false;

    if (v.canPlayType && v.canPlayType('video/mp4').replace(/no/, '')) {
      return true;
    }

    return false;
  },

  hexToRBG: function hexToRBG(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    console.log('yup!');
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  },

  isTouch: function isTouch() {
    return 'ontouchstart' in window;
  },

  pixelDensity: function pixelDensity() {
    var dpr = 1;
    if (window.devicePixelRatio !== undefined) dpr = window.devicePixelRatio;

    return dpr;
  },

  hasHistoryAPI: function hasHistoryAPI() {
    return !!(window.history && history.pushState);
  },

  validEmail: function validEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },

  validPostalCode: function validPostalCode(pc) {
    var re = new RegExp(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/);
    return re.test(pc);
  },

  valid10DigitPhoneNumber: function valid10DigitPhoneNumber(phone) {
    var re = new RegExp(/^\d{10}$/);
    return re.test(phone);
  }

};

module.exports = new Utils();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Utils = __webpack_require__(0);

var _Utils2 = _interopRequireDefault(_Utils);

var _PhoneMenu = __webpack_require__(5);

var _PhoneMenu2 = _interopRequireDefault(_PhoneMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MenuController(clickCallback) {

	this.clickCallback = clickCallback;
	this.phoneMenu = null;
	this.mapOpen = false;
	this.navOpen = false;
	this.navMode = 'flyout'; // can be'flyout' for drop down menu style or 'slideout' for phone type nav

	$(window).resize($.proxy(this.handleResize, this));

	console.log('HERE');
}

MenuController.prototype = {

	setupNav: function setupNav(type) {
		this.navMode = type;

		// FOR TABS AND DESKTOP MENU
		/*	if( type == 'flyout') {
  			//init the menu functionality
  		this.phoneMenu = null;
  			$('#navButton').on('click', $.proxy(function(e) {
  				if( this.navOpen ) {
  				this.closeNav();
  			} else {
  				$('#navMenu').css('display','block');
  				$('#navMenuSheet').animate( {'top':'0px'}, { duration: 200 } );
  					this.navOpen = true;
  					$('#navMenu').on('mouseleave',$.proxy(function(e){
  					this.closeNav();
  				},this));
  					_gaq.push(['_trackEvent', 'Menu', this.navMode, 'Open' ]);
  			}
  			},this));
  		//FOR MOBILE MENU
  	} else {*/

		if (!this.phoneMenu) {
			var menu_width = 300;
			if ($(window).width() < 640) menu_width = $(window).width() - 75;

			this.phoneMenu = new _PhoneMenu2.default({ 'width': menu_width });
			$(this.phoneMenu).on('openComplete', $.proxy(this.handleCompressedNavOpened, this));
			$(this.phoneMenu).on('closeComplete', $.proxy(this.handleCompressedNavClosed, this));
		}

		$('#navButton').on('click', $.proxy(function (e) {

			this.phoneMenu.toggle();

			if (this.phoneMenu.opened) {
				//_gaq.push(['_trackEvent', 'Menu', this.navMode, 'Open' ]);
				ga('send', 'event', 'Menu', this.navMode, 'Open');
			} else {
				//_gaq.push(['_trackEvent', 'Menu', this.navMode, 'Close' ]);
				ga('send', 'event', 'Menu', this.navMode, 'Close');
			}
		}, this));

		//}

		if (this.clickCallback) {
			//override clicks on nav
			$('#navMenu a').each($.proxy(function (i) {
				$($('#navMenu').children()[i]).on('click', { index: i }, $.proxy(function (e) {
					this.clickCallback(e);
				}, this));
			}, this));
		}

		this.handleResize();
	},

	handleCompressedNavOpened: function handleCompressedNavOpened() {
		$('html,body').css('overflow', 'hidden');
		$('html,body').on('touchmove', function (e) {
			e.preventDefault();
		});
	},

	handleCompressedNavClosed: function handleCompressedNavClosed() {
		$('html,body').css('overflow', 'visible');
		$('html,body').off('touchmove');

		//$('.container').css('transform','');
	},

	handleResize: function handleResize(e) {

		if ($(window).width() < 640 && this.phoneMenu !== null) {
			this.phoneMenu.setMenuWidth($(window).width() - 75);
			$('.navMenuContainer ul').width($(window).width() - 76);
		} else {
			this.phoneMenu.setMenuWidth(300);
			$('.navMenuContainer ul').width('');
		}
	},

	closeNav: function closeNav() {

		if (this.navMode == 'flyout') {
			$('#navMenu').off('mouseleave');
			//$('#navMenu').fadeOut(200);
			$('#navMenuSheet').animate({ 'top': '-450px' }, { duration: 200 });

			this.navOpen = false;
		} else {
			console.log('CLOSE MENU');
			this.phoneMenu.close();
		}

		//_gaq.push(['_trackEvent', 'Menu', this.navMode, 'Close' ]);
		ga('send', 'event', 'Menu', this.navMode, 'Close');
	},

	unsetNav: function unsetNav() {
		$('#navButton').off('click');
		$('#navButton').off('mouseenter');
		$('.navMenuContainer').css('display', '');
		this.navOpen = false;
	}

};

module.exports = MenuController;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _App = __webpack_require__(3);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ESLint Global var declaration
/* global appOptions */

// webpack include of the site SASS/CSS
__webpack_require__(14);

var app = new _App2.default(appOptions);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _MediaQuery = __webpack_require__(4);

var _MediaQuery2 = _interopRequireDefault(_MediaQuery);

var _MenuController = __webpack_require__(1);

var _MenuController2 = _interopRequireDefault(_MenuController);

var _Utils = __webpack_require__(0);

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function App(options) {

	// retreive options
	this.options = options || {};
	this.sitePage = this.options.page;
	this.jsPages = ['Entry', 'Explore', 'Guidelines', 'Jury', 'Submit', 'VideoEntry', 'Winners'];

	$('document').ready($.proxy(this.handleAppReady, this));

	this.alertFallback = false;
	if (typeof console === "undefined" || typeof console.log === "undefined") {
		console = {};
		if (this.alertFallback) {
			console.log = function (msg) {
				alert(msg);
			};
		} else {
			console.log = function () {};
		}
	}
}
/*
 * Main 1.0,  Matthew Quinn, GRAND Creative Inc.  Copyright 2012
 *
 *  Dependancies: JQuery >=1.8 and < 2.0
 *
 *  This is the main Javascript class for launching the app/web site.
*/

App.prototype = {

	handleAppReady: function handleAppReady() {

		//init the media query detector
		this.mq = new _MediaQuery2.default();
		this.mq.compareWidth = $('#mediaQueryDetector').width();

		$(window).on('mediaQueryChange', $.proxy(this.handleMediaQueryChange, this));
		//$(window).scroll( $.proxy( this.handleScroll, this ) );

		this.handlePageOpen(null, this.sitePage);

		//hide address bar on mobile
		//$(window).scrollTop(0);

		//avoid using the :hover pseudo class when touching elements
		if ('ontouchstart' in document) {
			$('body').removeClass('no-touch');
		}

		//INIT THE MENU
		this.menu = new _MenuController2.default();

		this.handleMediaQueryChange(null, $(window).width());

		$(window).scroll($.proxy(this.handleScroll, this));
		$(window).resize($.proxy(this.handleScroll, this));
	},

	handleScroll: function handleScroll(e) {
		this.adjustHeaderNav();
	},

	handleResize: function handleResize(e) {

		this.adjustHeaderNav();
	},

	adjustHeaderNav: function adjustHeaderNav() {
		var barHeight = parseInt($('nav .navButton').css('top')) * 2 + $('nav .navButton').height();

		if ($(window).scrollTop() > $('.logo').offset().top + barHeight && !_Utils2.default.isTouch()) {
			var offset = $(window).scrollTop() - ($('header').height() - barHeight);
			$('.touchBar').css('height', barHeight + 'px').fadeIn(200);
			$('nav .toggle span').css('color', '#4aa082');
			if ($(window).width() < 1024) {
				$('nav .donate').fadeOut();
			}
		} else if ($(window).scrollTop() > $('.logo').offset().top + barHeight) {
			$('.touchBar').css('height', barHeight + 'px').fadeIn(400);
			$('nav .toggle span').css('color', '#4aa082');
			if ($(window).width() < 1024) {
				$('nav .donate').fadeOut();
			}
		} else {
			$('header').css('top', '0px');
			$('.touchBar').fadeOut(300);
			$('nav .toggle span').css('color', '#fff');
			if ($(window).width() < 1024) {
				$('nav .donate').fadeIn();
			}
		}
	},

	handlePageOpen: function handlePageOpen(e, page) {

		//launch the current page's controller if its available
		if (typeof this.sitePage !== 'undefined' && this.sitePage !== '' && this.jsPages.indexOf(this.sitePage) > -1) {
			var PageController = __webpack_require__(6)("./" + this.sitePage + 'Controller');
			this.pageController = new PageController(this.options);
		} else {
			console.log('PAGE CONTROLLER NOT LOADED');
		}
	},

	handlePageClose: function handlePageClose(e, page) {

		//destroy the page conroller
		//this.pageController.destroy();
		//delete this.pageController;

	},

	handleMediaQueryChange: function handleMediaQueryChange(e, width) {

		console.log("WIDTH: " + width);

		//unset any break point related navigation
		this.menu.unsetNav();

		/* Do -Site Wide- specific actions when the browser is resized to a particular break point */

		if (width < 460) {//PHONES VERT

		}

		if (width >= 460 && width <= 640) {//PHONES HORZ

		}

		if (width < 640) {
			///PHONES & TINY TABS - BOTH ORIENTATIONS
			this.menu.setupNav('slideout');
		}

		if (width > 640 && width <= 1024) {// TABS

		}

		if (width >= 640) {
			// TABS & DESKTOP
			this.menu.setupNav('flyout');
		}

		if (width > 640 && width <= 768) {//TABS VERT

		}

		if (width > 768 && width <= 1024) {//TABS HORZ

		}

		if (width <= 1024) {//PHONES & TABS

		}

		if (width > 1024) {//DESKTOPS

		}
	}

};

module.exports = App;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* MediaQuery 1.0,  Matthew Quinn, GRAND Creative Inc.  Copyright 2012
 *
 *  Description:
 *    Injects a media query detector div on the page. When the div changes size via your css media queries
 *    it will handle any javascript that needs to be executed that is geared for that view.
 *
 *
 *  Input:
 *
 *
 *
 *  Dependancies: JQuery 1.8
 *
 *  Implementation
 *    within your css file, set the dector div width for each media query you need to detect.
 *
*/

function MediaQuery() {

  //private
  this.detector = $(document.createElement('div')), this.compareWidth = 0, this.detector.attr('id', 'mediaQueryDetector');
  this.detector.css({ 'position': 'absolute', 'top': '-100px', 'background-color': '#ccc', 'z-index': 0, height: '40px' });

  $('body').prepend(this.detector);

  this.compareWidth = this.detector.width();

  $(window).resize(this.handleResize);
};

MediaQuery.prototype = {

  handleResize: function handleResize() {

    if ($('#mediaQueryDetector').width() != this.compareWidth) {

      //a change has occurred so update the comparison variable
      this.compareWidth = $('#mediaQueryDetector').width();

      $(window).trigger('mediaQueryChange', [compareWidth]);
    }
  }

};

module.exports = MediaQuery;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Utils = __webpack_require__(0);

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PhoneMenu(options) {

	// retreive options
	this.options = options || {};

	this.opened = false;
	//container = element;
	this.menuWidth = this.options.width ? this.options.width : $(window).width();

	if (Modernizr.csstransitions && !_Utils2.default.isAndroid2() && !_Utils2.default.isWindowsPhone()) {
		$('.slide').each($.proxy(function (i, v) {

			$(v).css('-webkit-transition-property', '-webkit-transform');
			$(v).css('-moz-transition-property', '-moz-transform');
			$(v).css('-o-transition-property', '-o-transform');
			$(v).css('transitionDuration', '250ms');
			//$(this).css('transitionTimingFunction','cubic-bezier(0.175, 0.885, 0.320, 1.275)');
			$(v).css('transitionTimingFunction', 'ease');

			if (i === 1) {
				//fire the end transition only once.
				$(v).on('webkitTransitionEnd', $.proxy(this.animateComplete, this));
				$(v).on('msTransitionEnd', $.proxy(this.animateComplete, this));
				$(v).on('oTransitionEnd', $.proxy(this.animateComplete, this));
				$(v).on('transitionEnd', $.proxy(this.animateComplete, this));
			}
		}, this));
	}
}

//Public Functions

/* PhoneMenu 1.0,  Matthew Quinn, GRAND Creative Inc.  Copyright 2012
 *
 *  Description:
 *    animates a mobile menu much like what is popular in iOS to date. Menu will appear on the left and shift the whole site over when
 *    opened.
 *
 *  Input:
 *    element   your navigation bar that you want to move back and forth
 *    options   config options - none as of yet
 *
 *  Dependancies: JQuery 1.8, easing.js, Modernizer
 *
 *  Implementation
 *    apply the 'slide' class to any objects you want to shift over to make room for the nav menu.
 *
*/
PhoneMenu.prototype = {

	setMenuWidth: function setMenuWidth(w) {
		this.menuWidth = w;
		if (this.opened) this.moveMenu(this.menuWidth);
	},

	moveMenu: function moveMenu(distance) {

		$('.slide').each($.proxy(function (i, v) {

			if (Modernizr.csstransitions && !_Utils2.default.isAndroid2() && !_Utils2.default.isWindowsPhone()) {
				if (Modernizr.csstransforms3d) $(v).css('transform', 'translate3d(' + distance + 'px,0,0)');else $(v).css('transform', 'translateX(' + distance + 'px)');
			} else {
				$(v).stop();

				//run the complete function once.
				if (i === 0) {
					$(v).animate({ left: distance + "px" }, { duration: 250, complete: this.animateComplete, queue: false });
				} else {
					$(v).animate({ left: distance + "px" }, { duration: 250, queue: false });
				}
			}
		}, this));
	},

	animateComplete: function animateComplete(e) {
		console.log('COMPLETE', this.opened);
		if (this.opened) $(this).trigger('openComplete');else $(this).trigger('closeComplete');
	},

	toggle: function toggle() {

		if (this.opened) this.close();else this.open();
	},

	open: function open() {
		this.opened = true;
		this.moveMenu(this.menuWidth);
	},

	close: function close() {
		this.opened = false;
		this.moveMenu(0);
	}

};

module.exports = PhoneMenu;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./EntryController": 7,
	"./ExploreController": 8,
	"./GuidelinesController": 9,
	"./JuryController": 10,
	"./MenuController": 1,
	"./SubmitController": 11,
	"./VideoEntryController": 12,
	"./WinnersController": 13
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function EntryController() {

	$('.openOverlay').on('click', $.proxy(this.handleOverlayOpen, this));
	$('.artOverlay, .closeButton').on('click', $.proxy(this.handleOverlayClose, this));

	$('.statementReadMore').on('click', $.proxy(this.handleReadMore, this));

	if ($('.statementHolder').height() < parseInt($('.statementHolder').css('max-height'))) $('.statementReadMore').hide();

	$('.entry.art img').on('load', $.proxy(this.handleEntryLoad, this));
	$('.entry.art img').attr('src', $('.entry.art img').data('src'));

	$(window).resize($.proxy(this.handleResize, this));
	$(window).on('mediaQueryChange', $.proxy(this.handleMediaQueryChange, this));

	this.handleMediaQueryChange(null, $(window).width());
}

EntryController.prototype = {

	handleResize: function handleResize(e) {

		this.handleEntryLoad();
	},

	handleMediaQueryChange: function handleMediaQueryChange(e, width) {

		if (width < 640) {
			$('.entryArrow.next').css('right', '0px');
			$('.entryArrow.next').off('mouseenter mouseleave');
			$('.entryArrow.prev').css('left', '0px');
			$('.entryArrow.prev').off('mouseenter mouseleave');
		}

		if (width >= 640) {
			// TABS & DESKTOP
			$('.entryArrow.next').css('right', '-130px');
			$('.entryArrow.prev').css('left', '-130px');
			$('.entryArrow.next').hover(function (e) {
				$(this).animate({ 'right': '0px' }, 200);
			}, function (e) {
				$(this).animate({ 'right': '-130px' }, 200);
			});
			$('.entryArrow.prev').hover(function (e) {
				$(this).animate({ 'left': '0px' }, 200);
			}, function (e) {
				$(this).animate({ 'left': '-130px' }, 200);
			});
		}
	},

	handleEntryLoad: function handleEntryLoad(e) {

		if ($('.entry.art img').width() > $('.entry.art img').height()) {
			//landscape
			$('.entry.art img').css('width', '100%');
			$('.entry.art img').css('height', 'auto');
		} else {
			//portrait
			if ($(window).width() > 640) $('.entry.art a').css('height', '400px');else $('.entry.art a').css('height', '300px');

			$('.entry.art img').css('width', 'auto');
			$('.entry.art img').css('height', '100%');
		}

		var offset = $('.entry.art img').width() / 2 - $('.entry.art a div').width();

		if ($(window).width() > 640) {
			$('.entry.art a div').css('margin-left', offset + 'px');
			$('.entry.art a div').css('display', 'block');
		}

		$('.entry.art img').fadeIn(300);
	},

	handleReadMore: function handleReadMore(e) {
		$('.statementHolder').css('max-height', 'none');
		$('.statementReadMore').hide();
	},

	handleOverlayOpen: function handleOverlayOpen(e) {
		e.preventDefault();

		if ($(window).width() < 640) return;

		var image = $(e.currentTarget).attr('href');

		$('.artOverlay div').css('background-image', "url('/" + image + "')");
		$('.artOverlay').fadeIn(300);
		$('html,body').css('overflow', 'hidden');
	},

	handleOverlayClose: function handleOverlayClose(e) {
		$('.artOverlay').fadeOut(300);
		$('html,body').css('overflow', 'visible');
	}

};

module.exports = EntryController;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ExploreController() {

	$('#theme').on('change', $.proxy(this.handleThemeChange, this));
}

ExploreController.prototype = {

	handleThemeChange: function handleThemeChange(e) {

		console.log(window.location.pathname);

		var theme = $('#exploreTheme').val();
		//var section = $('#exploreSection').val();
		var url_path = window.location.pathname.split('/');
		var root = url_path[1];
		var section = '';

		if (url_path[2] == 'arts' || url_path[2] == 'writing' || url_path[2] == 'recits') {
			section = url_path[2] + '/';
		}

		window.location = '/' + root + '/' + section + $('#theme').val();
	}

};

module.exports = ExploreController;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function GuidelinesController(clickCallback) {

	//setup the FAQ buttons
	$('.faq a').each(function (i) {
		$(this).on('click', function () {

			//_gaq.push(['_trackEvent', 'GuidelinesPrizes', 'FAQ', 'Toggle', i ]);
			ga('send', 'event', 'GuidelinesPrizes', 'FAQ', 'Toggle', i);

			//CLOSE THE OTHERS FIRST
			$('.faq a').each(function (k) {
				if ($($(this).next()).is(":visible") && i != k) {
					$($(this).next()).slideUp(200);$(this).parent().parent().removeClass('open');
				}
			});

			$($(this).next()).slideToggle(200, function () {
				$('.faq').addClass('z').removeClass('z');
			}); //IE8 HACK to get the page to redraw

			if ($(this).parent().parent().hasClass('open')) {
				$(this).parent().parent().removeClass('open');
			} else {
				$(this).parent().parent().addClass('open');
			}
		});
	});

	$(window).scroll($.proxy(this.handleScroll, this));
}

module.exports = GuidelinesController;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function JuryController(clickCallback) {

	//setup the FAQ buttons
	$('.details a').each(function (i) {

		$(this).on('click', function () {

			//_gaq.push(['_trackEvent', 'Jury', 'Bio', 'Toggle', i ]);
			ga('send', 'event', 'Jury', 'Bio', 'Toggle', i);

			$($(this).next()).slideToggle(200);
			$(this).remove();
		});
	});
}

module.exports = JuryController;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function SubmitController(clickCallback) {

	this.maxWords = 400;
	this.maxsize = this.setupForm();
	this.form_type = '';

	$('#nextFormPage').on('click', $.proxy(this.validatePageOne, this));
	$('#submitFormButton').on('click', $.proxy(this.validatePageTwo, this));
	$('.radio.type').on('click', $.proxy(this.handleRadioTypeClick, this));
	$('.radio.group').on('click', $.proxy(this.handleRadioGroupClick, this));
	$('.radio.optin').on('click', $.proxy(this.handleRadioOptinClick, this));
	$('.radio.terms').on('click', $.proxy(this.handleRadioTermsClick, this));
	$('#ArtistStatement').on('keyup', $.proxy(this.handleWordCount, this));
	$('#ArtistStatement').on('paste', $.proxy(this.handleWordCountChange, this));

	$('#main_file').on('change', function () {
		$("#main_file_name").val(this.value.replace("C:\\fakepath\\", ""));
	});
	$('#extra_file1').on('change', function () {
		$("#extra_file_name1").val(this.value.replace("C:\\fakepath\\", ""));
	});
	$('#extra_file2').on('change', function () {
		$("#extra_file_name2").val(this.value.replace("C:\\fakepath\\", ""));
	});
	$('#extra_file3').on('change', function () {
		$("#extra_file_name3").val(this.value.replace("C:\\fakepath\\", ""));
	});
	$('#extra_file4').on('change', function () {
		$("#extra_file_name4").val(this.value.replace("C:\\fakepath\\", ""));
	});

	$('input:file').on('change', $.proxy(this.checkFileSize, this));

	$('.msContainer .closeButton').on('click', $.proxy(this.hideFormDownload, this));
	$('#showFormDownload').on('click', $.proxy(this.showFormDownload, this));

	$('#submitForm').on('submit', $.proxy(this.handleFormSubmit, this));
	$(window).resize($.proxy(this.handleResize, this));

	if ($('body').hasClass('EN')) {
		$('#WordCount').text(this.maxWords + ' words left');
	} else {
		$('#WordCount').text(this.maxWords + ' à 400 mots');
	}

	this.spamInterval = setInterval($.proxy(this.incrementSpamTimer, this), 1000);
	this.spamTime = 0;

	if (window.location.hash) {
		if (window.location.hash == '#manual') {
			this.showFormDownload();
		}
	}
}

SubmitController.prototype = {

	incrementSpamTimer: function incrementSpamTimer() {
		this.spamTime++;
		console.log('ST: ' + this.spamTime);
	},

	showFormDownload: function showFormDownload() {

		$('.manualSubmitOverlay').fadeIn(400);

		var offset = ($(window).height() - $('.msContainer').height()) / 2;
		$('.msContainer').css('margin-top', offset + 'px');
		ga('send', 'event', 'Submit', 'Download', 'Show');
	},

	hideFormDownload: function hideFormDownload() {

		$('.manualSubmitOverlay').fadeOut(400);
		ga('send', 'event', 'Submit', 'Download', 'Hide');
	},

	checkFileSize: function checkFileSize(e) {
		var files = e.target.files;
		var main = false;
		var accept_types_main = ["application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/msword", "text/rtf", "text/plain", "image/jpeg", "application/pdf"];

		if ($(e.target).attr('id') == 'main_file') {
			main = true;
		}

		if (files) {
			if (files[0].size > 5242880) {
				$(e.target).parent().parent().addClass('error');
			} else if (main && $.inArray(files[0].type, accept_types_main) < 0) {
				$(e.target).parent().parent().addClass('error');
			} else if (!main && files[0].type != 'image/jpeg') {
				$(e.target).parent().parent().addClass('error');
			} else {
				$(e.target).parent().parent().removeClass('error');
			}
		}

		//			console.log(main,$(e.target).attr('id'),files[0].type, !$.inArray(files[0].type,accept_types_main) )
	},

	formSuccess: function formSuccess(responseText, statusText, xhr, $form) {
		console.log('status: ' + statusText + '\n\nresponseText: \n' + responseText + '\n\nThe output div should have already been updated with the responseText.');
	},

	handleResize: function handleResize() {
		this.setupForm();
	},

	handleWordCount: function handleWordCount(e) {
		var words = $('#ArtistStatement').val().split(/\b[\s,\.-:;]*/);
		var wordcount = words.length;
		var wordsLeft = this.maxWords - wordcount;

		if (wordsLeft < 10 && wordsLeft > 0) {
			$('#WordCount').css('font-weight', '700');
			$('#WordCount').css('color', '');
			$('#ArtistStatement').off('keypress');
		} else if (wordsLeft <= 0) {
			$('#WordCount').css('color', '#ee145b');
			$('#ArtistStatement').on('keypress', function (e) {
				e.preventDefault();
			});
			//_gaq.push(['_trackEvent', 'Submit', 'WordCount', 'RunOut' ]);
			ga('send', 'event', 'Submit', 'WordCount', 'RunOut');
		} else {
			$('#ArtistStatement').off('keypress');
			$('#WordCount').css('color', '');
			$('#WordCount').css('font-weight', '');
		}

		if ($('body').hasClass('EN')) {
			$('#WordCount').text(wordsLeft + ' words left');
		} else {
			$('#WordCount').text(wordsLeft + ' à 400 mots');
		}
	},

	handleWordCountChange: function handleWordCountChange() {

		setTimeout($.proxy(function () {
			var words = $('#ArtistStatement').val().split(/\b[\s,\.-:;]*/);
			var wordcount = words.length;
			var wordsLeft = this.maxWords - wordcount;

			if (wordsLeft <= 0) {
				$('#WordCount').css('color', '#ee145b');
				$('#WordCount').css('font-weight', '700');
				$('#ArtistStatement').on('keypress', function (e) {
					e.preventDefault();
				});
				//_gaq.push(['_trackEvent', 'Submit', 'WordCount', 'OverPaste' ]);
				ga('send', 'event', 'Submit', 'WordCount', 'OverPaste');
			} else {
				$('#ArtistStatement').off('keypress');
				$('#WordCount').css('font-weight', '');
			}

			if ($('body').hasClass('EN')) {
				$('#WordCount').text(wordsLeft + ' words left');
			} else {
				$('#WordCount').text(wordsLeft + ' à 400 mots');
			}
		}, this), 100);
	},

	handleRadioOptinClick: function handleRadioOptinClick(e) {

		$('.radio.optin').each(function () {
			$(this).removeClass('select');
		});

		$(e.currentTarget).addClass('select');
		$('#optin').val($(e.currentTarget).data('value'));
	},

	handleRadioTypeClick: function handleRadioTypeClick(e) {

		$('.radio.type').each(function () {
			$(this).removeClass('select');
		});

		$(e.currentTarget).addClass('select');
		$('#submit_type').val($(e.currentTarget).data('value'));
	},

	handleRadioGroupClick: function handleRadioGroupClick(e) {

		$('.radio.group').each(function () {
			$(this).removeClass('select');
		});

		$(e.currentTarget).addClass('select');
		$('#group_submission').val($(e.currentTarget).data('value'));
	},

	handleRadioTermsClick: function handleRadioTermsClick(e) {

		$('.radio.terms').each(function () {
			$(this).removeClass('select');
		});

		$(e.currentTarget).addClass('select');
		$('#terms_agreed').val($(e.currentTarget).data('value'));
	},

	validatePageOne: function validatePageOne() {

		$('#nextFormPage').off('click');
		$('#nextFormPage').css('opacity', '0.2');

		var error = false;

		$('.page1 .formField.required').each(function (i) {

			//check the input field
			if ($(this).children('input').val() === '' || $(this).children('select').val() === '') {
				$(this).addClass('error');
				error = true;
			} else if ($(this).hasClass('error')) {
				$(this).removeClass('error');
			}
		});

		if (error) {
			$('#nextFormPage').on('click', $.proxy(this.validatePageOne, this));
			$('#nextFormPage').css('opacity', '1');
			//IE8 HACK VVVV .. the complete function forces a redraw in IE8
			$('.page1 .formError').slideDown(200, function () {
				$('.submitForm').addClass('s').removeClass('s');
			});
			//IE8 HACK ^^^^
			//_gaq.push(['_trackEvent', 'Submit', 'Page1', 'Error' ]);
			ga('send', 'event', 'Submit', 'Page1', 'Error');

			$(window).resize();
		} else {
			$('.page1').css('padding-bottom', '0px');
			$('.page2').css('padding-bottom', '100px');
			$('.page1 .formError').slideUp(200);
			$('.slideContainer.submitForm').animate({ 'margin-left': '-100%' }, 300);
			$('html,body').animate({ scrollTop: $('.list.submit').offset().top - 110 }, 350);

			//_gaq.push(['_trackEvent', 'Submit', 'Page1', 'Complete' ]);
			ga('send', 'event', 'Submit', 'Page1', 'Complete');
		}
	},

	validatePageTwo: function validatePageTwo() {

		$('#submitFormButton').off('click');
		$('#submitFormButton').addClass('submitting');

		var error = false;

		$('.page2 .formField.required').each(function (i) {

			//check the input field
			if ($(this).children('input').val() === '' || $(this).children('textarea').val() === '') {
				$(this).addClass('error');
				error = true;
			} else if ($(this).hasClass('error')) {
				$(this).removeClass('error');
			}
		});

		if ($('#main_file_name').val() === '') {
			error = true;
			$('#mainFile').addClass('error');
		}

		if (parseInt($('#WordCount').text()) < 0) {
			error = true;
			$('#asContainer').addClass('error');
		}

		if (error) {
			$('#submitFormButton').on('click', $.proxy(this.validatePageTwo, this));
			$('#submitFormButton').css('opacity', '1');
			$('#submitFormButton').removeClass('submitting');
			//IE8 HACK VVVV .. the complete function forces a redraw in IE8
			$('.page2 .formError').slideDown(200, function () {
				$('.submitForm').addClass('s').removeClass('s');
			});
			//_gaq.push(['_trackEvent', 'Submit', 'Page2', 'Error' ]);
			ga('send', 'event', 'Submit', 'Page2', 'Error');
		} else {
			$('.page2 .formError').slideUp(200);

			console.log('ST TEST:' + this.spamTime);
			clearInterval(this.spamInterval);

			if (this.spamTime > 10) {
				$('#submitForm').attr('action', "/submit/process.php").submit();
			}

			//_gaq.push(['_trackEvent', 'Submit', 'Page2', 'Complete' ]);
			ga('send', 'event', 'Submit', 'Page2', 'Complete');
		}
	},

	handleFormSubmit: function handleFormSubmit() {

		$('#submitForm').ajaxSubmit({ success: $.proxy(this.handleFormSuccess, this), error: $.proxy(this.handleFormError, this), dataType: 'json' });
		return false;
	},

	handleFormError: function handleFormError(responseText, statusText, xhr, $form) {
		alert('There has been a problem with your submission. We\'re sorry for the inconvenience. Please contact ourstory@HistoricaCanada.ca and let us know that you received the following error message:' + responseText);
		//_gaq.push(['_trackEvent', 'Submit', 'Page3', 'ErrorUnknown' ]);
		ga('send', 'event', 'Submit', 'Page3', 'ErrorUnknown');
	},

	handleFormSuccess: function handleFormSuccess(responseText, statusText, xhr, $form) {
		console.log(responseText);

		if (responseText.result != 1) {
			alert('There has been a problem with your submission. We\'re sorry for the inconvenience. Please contact ourstory@HistoricaCanada.ca and let us know that you received the following error message:' + responseText.message + " Code: " + responseText.result);
			//_gaq.push(['_trackEvent', 'Submit', 'Page3', 'Error' ]);
			ga('send', 'event', 'Submit', 'Page3', 'Error');
		} else {

			$('.page1, .page2').css('height', '0px');
			$('.slideContainer.submitForm').animate({ 'margin-left': '-200%' }, 500);
			$('html,body').animate({ scrollTop: $('.list.submit').offset().top - 100 }, 350);
			$('.list.submit').css('display', 'none');

			//_gaq.push(['_trackEvent', 'Submit', 'Page3', 'Success' ]);
			ga('send', 'event', 'Submit', 'Page3', 'Success');
		}
	},

	setupForm: function setupForm() {

		if (isMobile.any) {

			$('.topCallout .nosubmit').css('display', 'block');
			$('.topCallout .submit').css('display', 'none');
			$('.submitForm').css('display', 'none');
			$('.list.submit').css('display', 'none');
		} else {

			$('.topCallout .nosubmit').css('display', 'none');
			$('.topCallout .submit').css('display', 'block');
			$('.submitForm').css('display', 'block');
			$('.list.submit').css('display', 'block');
		}
	}

};

module.exports = SubmitController;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function VideoEntryController(clickCallback) {
	console.log('BAM');

	$('.viewTranscript').on('click', function (e) {
		console.log('BAM', $('.transcript'));
		$('.transcript').slideToggle();
	});
}

module.exports = VideoEntryController;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function WinnersController() {

	this.currentNavPage = 1;
	this.pages = 1;
	this.perpage = 0;
	this.numberYears = 0;
	this.yearWidth = 0;

	this.setupYearNav();

	if (this.pages > 1) this.setCurrentYearNav();

	$('.yearNav .arrow').on('click', $.proxy(this.handleYearNavClick, this));

	$(window).resize($.proxy(this.handleResize, this));
	$(window).on('mediaQueryChange', $.proxy(this.handleMediaQueryChange, this));
}

WinnersController.prototype = {

	handleResize: function handleResize() {

		this.setupYearNav();
	},

	handleYearNavClick: function handleYearNavClick(e) {

		if (!$(e.currentTarget).hasClass('disabled')) {
			if ($(e.currentTarget).hasClass('nextArrow')) {
				this.handleYearNextPage(e);
			} else {
				this.handleYearBackPage(e);
			}
		}
	},

	handleYearNextPage: function handleYearNextPage(e, page) {
		var duration = 300;

		if ((typeof page === 'undefined' ? 'undefined' : _typeof(page)) !== undefined && page >= 1 && page <= this.pages) {
			this.currentNavPage = page;
			duration = 0;
		} else {
			this.currentNavPage++;
		}

		var index = this.currentNavPage * this.perpage;
		var tiles = this.perpage;
		var offset = 0;

		if (index > this.numberYears) {
			tiles = this.perpage - (index - this.numberYears);
			offset = (this.currentNavPage - 2) * (this.yearWidth * this.perpage) + tiles * this.yearWidth;
		} else {
			offset = (this.currentNavPage - 1) * (this.yearWidth * this.perpage);
		}

		$('.years').animate({ 'left': -offset }, duration);

		this.setupYearNavButtons();
	},

	handleYearBackPage: function handleYearBackPage(e) {

		this.currentNavPage--;
		var tiles = this.perpage;
		var offset = (this.currentNavPage - 1) * (this.yearWidth * this.perpage);

		$('.years').animate({ 'left': -offset }, 300);

		this.setupYearNavButtons();
	},

	setupYearNav: function setupYearNav() {

		this.numberYears = $('.years div').length;
		this.yearWidth = $('.years div').width() + 1;
		var yearsWidth = this.numberYears * this.yearWidth + this.numberYears;
		var containerWidth = $('.yearNav .yearsContainer').width();

		if (yearsWidth < containerWidth) {
			$('.years').css('margin', 'auto');
		}

		this.perpage = Math.round(containerWidth / this.yearWidth);
		console.log(this.perpage, containerWidth, this.yearWidth);

		$('.years').width(yearsWidth);

		if (yearsWidth > containerWidth) {
			this.pages = Math.ceil(yearsWidth / containerWidth);
		}

		this.setupYearNavButtons();
	},

	setupYearNavButtons: function setupYearNavButtons() {

		$('.yearNav .arrow').removeClass('disabled');

		if (this.pages == 1) {
			$('.yearNav .arrow').addClass('disabled');
		} else if (this.currentNavPage == 1) {
			$('.yearNav .backArrow').addClass('disabled');
		} else if (this.currentNavPage == this.pages) {
			$('.yearNav .nextArrow').addClass('disabled');
		}
	},

	setCurrentYearNav: function setCurrentYearNav() {

		var start_year = $('.years').data('start');
		var current_year = $('.years').data('current');

		var index = current_year - start_year + 1;

		var onpage = Math.ceil(index / this.perpage);

		console.log('ON PAGE', onpage, index, this.perpage);

		this.handleYearNextPage(null, onpage);
	},

	handleMediaQueryChange: function handleMediaQueryChange(e, width) {

		if (width < 640) {
			this.setupYearNav();

			if (this.pages > 1) this.setCurrentYearNav();
		}

		if (width >= 640) {
			// TABS & DESKTOP
			this.setupYearNav();

			if (this.pages > 1) this.setCurrentYearNav();
		}
	}

};

module.exports = WinnersController;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.bundle.js